/* ========================================================
   CHEIKH FERRO. — SHOPIFY LIQUID THEME JAVASCRIPT
   1-Click Direct COD Order + Google Sheets Integration
   No Redirects to Shopify Checkout Ever!
   ======================================================== */

function changeCfQty(delta) {
  var qtyInput = document.getElementById('cfQuantity');
  var currentQty = qtyInput ? (parseInt(qtyInput.value) || 1) : 1;
  var newQty = Math.max(1, currentQty + delta);
  if (qtyInput) {
    qtyInput.value = newQty;
    qtyInput.setAttribute('value', newQty);
  }
  window.CURRENT_CF_QTY = newQty;
  updateCfTotalDisplay(newQty);
}

function onCfQtyChange(val) {
  var newQty = Math.max(1, parseInt(val) || 1);
  window.CURRENT_CF_QTY = newQty;
  updateCfTotalDisplay(newQty);
}

function updateCfTotalDisplay(qty) {
  var unitPriceInput = document.getElementById('cfProductPrice');
  var displayTotal = document.getElementById('cfDisplayTotal');
  if (unitPriceInput && displayTotal) {
    var unitPrice = parseFloat(unitPriceInput.value.replace(/[^0-9.]/g, '')) || 0;
    var grandTotal = unitPrice * qty;
    displayTotal.innerText = grandTotal.toFixed(0);
  }
}

function closeCfModal() {
  var modal = document.getElementById('cfOrderSuccessModal');
  if (modal) modal.style.display = 'none';
  // Reload page to reflect cleared cart state if on cart page
  if (window.location.pathname.indexOf('/cart') !== -1) {
    window.location.reload();
  }
}

function openCartCodModal() {
  var modal = document.getElementById('cfCartCodModal');
  if (modal) modal.style.display = 'flex';
}

function closeCartCodModal() {
  var modal = document.getElementById('cfCartCodModal');
  if (modal) modal.style.display = 'none';
}

function copyCfOrderId() {
  var orderIdText = document.getElementById('modalOrderId');
  if (orderIdText) {
    navigator.clipboard.writeText(orderIdText.innerText);
    alert('تم نسخ رقم الطلب إلى الحافظة!');
  }
}

// --- Anti-spam / anti-tamper helpers -----------------------------------

// Honeypot check: real visitors never see or fill this field, bots often do.
function cfHoneypotTripped(fieldId) {
  var el = document.getElementById(fieldId);
  return !!(el && el.value && el.value.trim().length > 0);
}

// Very basic client-side throttle: blocks rapid repeat submissions from the
// same browser (accidental double-clicks and naive scripted spam through the
// visible form). This is a UX/spam-reduction measure only — it cannot stop
// someone who calls the webhook URL directly, since that requires a
// server-side proxy in front of the Google Sheets endpoint.
function cfIsRateLimited() {
  try {
    var last = parseInt(sessionStorage.getItem('cfLastOrderSubmitAt') || '0', 10);
    var now = Date.now();
    if (now - last < 15000) return true; // 15s between submissions
    sessionStorage.setItem('cfLastOrderSubmitAt', String(now));
    return false;
  } catch (e) {
    return false; // if sessionStorage is unavailable, don't block the order
  }
}

// Re-fetch the authoritative unit price from Shopify's own product JSON
// instead of trusting the hidden form field, which can be edited client-side
// (e.g. via DevTools) before submit. Falls back to the hidden field's value
// if the lookup fails, so the form still works offline/on error.
function cfGetVerifiedUnitPrice(productUrl, variantId, fallbackPrice) {
  if (!productUrl) return Promise.resolve(fallbackPrice);
  return fetch(productUrl + '.js')
    .then(function (res) { return res.ok ? res.json() : null; })
    .then(function (data) {
      if (!data || !data.variants) return fallbackPrice;
      var variant = null;
      if (variantId) {
        variant = data.variants.filter(function (v) { return String(v.id) === String(variantId); })[0];
      }
      if (!variant) variant = data.variants[0];
      return variant ? (variant.price / 100) : fallbackPrice;
    })
    .catch(function () { return fallbackPrice; });
}

document.addEventListener('DOMContentLoaded', function () {
  // 1. Single Product Quick COD Form Submission (No Redirect!)
  var form = document.getElementById('CheikhFerroCODForm');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      // Bot check: if the hidden honeypot field got filled, silently drop it.
      if (cfHoneypotTripped('cfWebsite')) return;

      // Throttle: block rapid repeat submissions from this browser.
      if (cfIsRateLimited()) {
        var throttledMsg = document.getElementById('cfResponseMessage');
        if (throttledMsg) {
          throttledMsg.style.color = '#f59e0b';
          throttledMsg.innerText = 'تم تسجيل طلب قبل قليل، الرجاء الانتظار قليلاً قبل إعادة المحاولة.';
        }
        return;
      }

      var submitBtn = document.getElementById('cfSubmitBtn');
      var msg = document.getElementById('cfResponseMessage');

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerText = 'جاري تسجيل طلبك... ⏳';
      }

      var productName = document.getElementById('cfProductName') ? document.getElementById('cfProductName').value : '';
      
      var qtyInput = document.getElementById('cfQuantity');
      var parsedQty = qtyInput ? parseInt(qtyInput.value) : 1;
      var quantity = window.CURRENT_CF_QTY || (isNaN(parsedQty) ? 1 : parsedQty);
      if (quantity < 1) quantity = 1;

      var fullName = document.getElementById('cfFullName') ? document.getElementById('cfFullName').value.trim() : '';
      var phone = document.getElementById('cfPhone') ? document.getElementById('cfPhone').value.trim() : '';
      var city = document.getElementById('cfCity') ? document.getElementById('cfCity').value.trim() : '';
      var address = document.getElementById('cfAddress') ? document.getElementById('cfAddress').value.trim() : '';
      var notes = document.getElementById('cfNotes') ? document.getElementById('cfNotes').value.trim() : '';
      var fallbackUnitPrice = document.getElementById('cfProductPrice') ? parseFloat(document.getElementById('cfProductPrice').value.replace(/[^0-9.]/g, '')) : 0;
      var productUrl = document.getElementById('cfProductUrl') ? document.getElementById('cfProductUrl').value : '';
      var variantId = document.getElementById('cfVariantId') ? document.getElementById('cfVariantId').value : '';
      var randomId = 'CF-' + Math.floor(100000 + Math.random() * 900000);

      var sheetUrl = window.GOOGLE_SHEET_URL && window.GOOGLE_SHEET_URL.trim().length > 10 ? window.GOOGLE_SHEET_URL.trim() : null;

      // Re-verify the unit price against Shopify's own product data before
      // recording the order, instead of trusting the hidden form field as-is.
      cfGetVerifiedUnitPrice(productUrl, variantId, fallbackUnitPrice).then(function (unitPrice) {
        var totalAmount = unitPrice * quantity;

        var params = new URLSearchParams();
        params.append('orderId', randomId);
        params.append('name', fullName);
        params.append('phone', phone);
        params.append('city', city);
        params.append('address', address);
        params.append('product', productName);
        params.append('unitPrice', unitPrice.toFixed(0) + ' د.م.');
        params.append('quantity', quantity.toString());
        params.append('total', totalAmount.toFixed(0) + ' د.م.');
        params.append('notes', notes);

        // A. Post parameters to Google Sheets Web App
        if (sheetUrl) {
          fetch(sheetUrl, {
            method: 'POST',
            mode: 'no-cors',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: params.toString()
          }).catch(function(err) { console.log('Sheet post:', err); });
        }

        // B. Clear Shopify Cart silently so /cart stays clean!
        fetch('/cart/clear.js', { method: 'POST' }).catch(function() {});

        cfShowSingleOrderSuccess(randomId, fullName, phone, city, address, productName, unitPrice, quantity, totalAmount, msg, submitBtn, form);
      });
    });
  }

  // Helper: show the success modal for the single-product COD form.
  function cfShowSingleOrderSuccess(randomId, fullName, phone, city, address, productName, unitPrice, quantity, totalAmount, msg, submitBtn, form) {
      // C. Show Order Success Modal directly on screen
      setTimeout(function() {
        if (msg) {
          msg.style.color = '#10b981';
          msg.innerText = 'تم تسجيل طلبك بنجاح! شكراً لك.';
        }

        if (document.getElementById('modalOrderId')) document.getElementById('modalOrderId').innerText = randomId;
        if (document.getElementById('modalFullName')) document.getElementById('modalFullName').innerText = fullName;
        if (document.getElementById('modalPhone')) document.getElementById('modalPhone').innerText = phone;
        if (document.getElementById('modalCity')) document.getElementById('modalCity').innerText = city;
        if (document.getElementById('modalAddress')) document.getElementById('modalAddress').innerText = address;
        if (document.getElementById('modalGrandTotal')) document.getElementById('modalGrandTotal').innerText = totalAmount.toFixed(0);

        var waText = encodeURIComponent(
          'مرحباً Cheikh Ferro 🇲🇦، أود متابعة طلبي رقم: ' + randomId +
          '\nالاسم: ' + fullName +
          '\nالهاتف: ' + phone +
          '\nالمدينة: ' + city +
          '\nالعنوان: ' + address +
          '\nالمنتج: ' + productName +
          '\nثمن الوحدة: ' + unitPrice.toFixed(0) + ' د.م.' +
          '\nالكمية: ' + quantity +
          '\nالإجمالي: ' + totalAmount.toFixed(0) + ' د.م.'
        );

        var waLink = document.getElementById('cfWhatsappLink');
        if (waLink) {
          waLink.href = 'https://wa.me/212716242336?text=' + waText;
        }

        var modal = document.getElementById('cfOrderSuccessModal');
        if (modal) modal.style.display = 'flex';

        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerText = 'تأكيد الطلب الآن — الدفع عند الاستلام';
        }

        form.reset();
        window.CURRENT_CF_QTY = 1;
        updateCfTotalDisplay(1);
      }, 400);
  }

  // 2. Full Cart Page Direct COD Submission (No Checkout Redirect!)
  var cartForm = document.getElementById('cfCartCodForm');
  if (cartForm) {
    cartForm.addEventListener('submit', function (e) {
      e.preventDefault();

      // Bot check: if the hidden honeypot field got filled, silently drop it.
      if (cfHoneypotTripped('cfCartWebsite')) return;

      // Throttle: block rapid repeat submissions from this browser.
      if (cfIsRateLimited()) return;

      var submitBtn = document.getElementById('cfCartSubmitBtn');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerText = 'جاري إرسال جميع منتجات السلة... ⏳';
      }

      var fullName = document.getElementById('cfCartFullName') ? document.getElementById('cfCartFullName').value.trim() : '';
      var phone = document.getElementById('cfCartPhone') ? document.getElementById('cfCartPhone').value.trim() : '';
      var city = document.getElementById('cfCartCity') ? document.getElementById('cfCartCity').value.trim() : '';
      var address = document.getElementById('cfCartAddress') ? document.getElementById('cfCartAddress').value.trim() : '';
      
      var itemRows = document.querySelectorAll('.cf-cart-item-row');
      var itemNames = [];
      var totalQty = 0;

      itemRows.forEach(function(row) {
        var title = row.getAttribute('data-title') || 'منتج';
        var qty = parseInt(row.getAttribute('data-qty')) || 1;
        totalQty += qty;
        itemNames.push(title + ' (x' + qty + ')');
      });

      var productListStr = itemNames.join(' + ');
      var fallbackTotalPriceEl = document.getElementById('cfCartTotalPrice');
      var fallbackTotalPriceStr = fallbackTotalPriceEl ? (fallbackTotalPriceEl.getAttribute('data-total') || fallbackTotalPriceEl.innerText) : '0';
      var randomId = 'CF-' + Math.floor(100000 + Math.random() * 900000);

      var sheetUrl = window.GOOGLE_SHEET_URL && window.GOOGLE_SHEET_URL.trim().length > 10 ? window.GOOGLE_SHEET_URL.trim() : null;

      // Re-verify the cart total against Shopify's own /cart.js (server-side
      // session state) instead of trusting the number shown in the DOM,
      // which can be edited client-side before submit.
      fetch('/cart.js').then(function (res) { return res.ok ? res.json() : null; })
        .catch(function () { return null; })
        .then(function (cartData) {
          var totalPriceStr = (cartData && typeof cartData.total_price === 'number')
            ? (cartData.total_price / 100).toFixed(0)
            : fallbackTotalPriceStr;

          var params = new URLSearchParams();
          params.append('orderId', randomId);
          params.append('name', fullName);
          params.append('phone', phone);
          params.append('city', city);
          params.append('address', address);
          params.append('product', productListStr);
          params.append('unitPrice', 'طلب سلة شامل');
          params.append('quantity', totalQty.toString());
          params.append('total', totalPriceStr + ' د.م.');
          params.append('notes', 'طلب سلة كامل');

          if (sheetUrl) {
            fetch(sheetUrl, {
              method: 'POST',
              mode: 'no-cors',
              headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
              body: params.toString()
            }).catch(function(err) { console.log('Sheet cart post:', err); });
          }

          // Clear Shopify Cart silently
          fetch('/cart/clear.js', { method: 'POST' }).catch(function() {});

          cfShowCartOrderSuccess(randomId, fullName, phone, city, address, productListStr, totalQty, totalPriceStr, submitBtn, cartForm);
        });
    });
  }

  function cfShowCartOrderSuccess(randomId, fullName, phone, city, address, productListStr, totalQty, totalPriceStr, submitBtn, cartForm) {
      setTimeout(function() {
        closeCartCodModal();

        if (document.getElementById('modalOrderId')) document.getElementById('modalOrderId').innerText = randomId;
        if (document.getElementById('modalFullName')) document.getElementById('modalFullName').innerText = fullName;
        if (document.getElementById('modalPhone')) document.getElementById('modalPhone').innerText = phone;
        if (document.getElementById('modalCity')) document.getElementById('modalCity').innerText = city;
        if (document.getElementById('modalAddress')) document.getElementById('modalAddress').innerText = address;
        if (document.getElementById('modalGrandTotal')) document.getElementById('modalGrandTotal').innerText = totalPriceStr;

        var waText = encodeURIComponent(
          'مرحباً Cheikh Ferro 🇲🇦، أود متابعة طلب السلة رقم: ' + randomId +
          '\nالاسم: ' + fullName +
          '\nالهاتف: ' + phone +
          '\nالمدينة: ' + city +
          '\nالعنوان: ' + address +
          '\nالمنتجات: ' + productListStr +
          '\nالعدد الكلي: ' + totalQty +
          '\nالإجمالي: ' + totalPriceStr + ' د.م.'
        );

        var waLink = document.getElementById('cfWhatsappLink');
        if (waLink) {
          waLink.href = 'https://wa.me/212716242336?text=' + waText;
        }

        var modal = document.getElementById('cfOrderSuccessModal');
        if (modal) modal.style.display = 'flex';

        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerText = 'تأكيد طلب السلة — الدفع عند الاستلام';
        }

        cartForm.reset();
      }, 400);
  }

  // 3. AJAX Add to Cart for Product Cards
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cf-add-to-cart-btn');
    if (!btn || btn.disabled) return;
    
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    e.preventDefault();
    e.stopPropagation();

    var originalHtml = btn.innerHTML;
    btn.classList.add('is-loading');
    btn.innerHTML = '<span>جاري الإضافة... ⏳</span>';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('Add to cart failed');
      return res.json();
    })
    .then(function(item) {
      btn.classList.remove('is-loading');
      btn.classList.add('is-success');
      btn.innerHTML = '<span>✓ تمت الإضافة بنجاح</span>';

      // Update cart count badge in header
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var badges = document.querySelectorAll('a[href="/cart"] span, .cf-cart-count, [aria-label="السلة"] span');
          badges.forEach(function(badge) {
            badge.innerText = cart.item_count;
          });
        })
        .catch(function() {});

      setTimeout(function() {
        btn.classList.remove('is-success');
        btn.innerHTML = originalHtml;
      }, 2000);
    })
    .catch(function(err) {
      btn.classList.remove('is-loading');
      btn.innerHTML = '<span>فشلت الإضافة ✕</span>';
      setTimeout(function() {
        btn.innerHTML = originalHtml;
      }, 2000);
    });
  });

  // 4. Smooth scroll to COD Quick Order form (Landing Page CTA buttons)
  document.addEventListener('click', function(e) {
    var scrollBtn = e.target.closest('.cf-scroll-to-order');
    if (scrollBtn) {
      e.preventDefault();
      var targetForm = document.getElementById('CheikhFerroCODForm') || document.querySelector('.cf-quick-order-container');
      if (targetForm) {
        targetForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
        targetForm.style.transition = 'box-shadow 0.3s ease';
        targetForm.style.boxShadow = '0 0 0 3px var(--accent-gold)';
        setTimeout(function() {
          targetForm.style.boxShadow = '';
        }, 1200);
      }
    }
  });

  // 5. Landing Page Urgency Countdown Timer
  var timerEl = document.getElementById('cfLpCountdownTimer');
  if (timerEl) {
    var hours = 4, minutes = 37, seconds = 45;
    setInterval(function() {
      if (seconds > 0) {
        seconds--;
      } else {
        seconds = 59;
        if (minutes > 0) {
          minutes--;
        } else {
          minutes = 59;
          if (hours > 0) hours--;
          else hours = 5;
        }
      }
      var hStr = hours < 10 ? '0' + hours : hours;
      var mStr = minutes < 10 ? '0' + minutes : minutes;
      var sStr = seconds < 10 ? '0' + seconds : seconds;
      timerEl.innerText = hStr + ':' + mStr + ':' + sStr;
    }, 1000);
  }

  // 6. Landing Page FAQ Accordion Toggle
  document.querySelectorAll('.cf-faq-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = this.closest('.cf-faq-item');
      if (item) {
        item.classList.toggle('is-open');
      }
    });
  });

  // 7. Auto-Remove Third-Party Branding from Product Description
  // Removes any HTML blocks or images referencing competitor brands
  (function cleanProductDescription() {
    var descBox = document.querySelector('.cf-lp-description-box');
    if (!descBox) return;

    var BLOCKED_KEYWORDS = ['ayouch', 'ayouchtools', 'ayouchtool', 'www.ayouch', 'support@ayouch'];

    // Remove full block elements (divs, sections, headers) containing blocked text
    var allEls = descBox.querySelectorAll('*');
    allEls.forEach(function(el) {
      var txt = (el.textContent || el.innerText || '').toLowerCase();
      var src = (el.getAttribute('src') || el.getAttribute('href') || '').toLowerCase();
      var blocked = BLOCKED_KEYWORDS.some(function(kw) {
        return txt.includes(kw) || src.includes(kw);
      });
      if (blocked) {
        // Only remove block-level or image elements to avoid false positives on small spans
        var tag = el.tagName.toLowerCase();
        if (['div','section','header','footer','table','figure','img','a','p','span','h1','h2','h3','h4','h5','h6','ul','li','tr','td'].indexOf(tag) !== -1) {
          el.remove();
        }
      }
    });

    // Remove any remaining images whose src contains blocked domains
    descBox.querySelectorAll('img').forEach(function(img) {
      var src = (img.getAttribute('src') || '').toLowerCase();
      if (BLOCKED_KEYWORDS.some(function(kw) { return src.includes(kw); })) {
        img.remove();
      }
    });

    // Remove inline style blocks that reference Ayouch (full landing page HTML pastes)
    descBox.querySelectorAll('[style*="background"]').forEach(function(el) {
      var txt = el.innerHTML.toLowerCase();
      if (BLOCKED_KEYWORDS.some(function(kw) { return txt.includes(kw); })) {
        el.remove();
      }
    });
  })();

});

